import { PartySource, PartyTypes } from '../enums';

export const numberTypeToStringMap = {
  [PartyTypes.reservation]: 'reservation',
  [PartyTypes.walkIn]: 'walk-in',
  [PartyTypes.order]: 'order',
  [PartyTypes.togo]: 'togo',
};

export const sourceToStringMap = {
  [PartySource.noSource]: 'n/a',
  [PartySource.manager]: 'manager',
  [PartySource.public]: 'public',
  [PartySource.api]: 'api',
  [PartySource.square]: 'square',
  [PartySource.sms]: 'sms',
  [PartySource.google]: 'google',
};

export const DEFAULT_AUTO_REMOVE_HOURS = 12;
